<!--专题讲座-->
<template>
  <div class="app_container">
    <!--操作栏-->
    <div class="filter_container">
      <ExcelImport
        class="m-l-10"
        butnPremission="topicLectureOtherTrain:import"
        butnTitle="导入其他集中培训记录"
        modalTitle="导入其他集中培训记录"
        :downloadTemplate="otherTrainRecordTemplate"
        :importApi="importApi"
        @importSuccess="importSuccess"
      />
      <div class="search_right">
        <Search class="search-wrapper" @search="searchHandle" :lectureTypes="lectureTypes" topicPlacehodler="请输入培训名称" @changeTopic="changeTopic" />
      </div>
    </div>
    <TopicHeader :type="3" :info="currentTopicInfo"/>
    <!--表格内容栏-->
    <div class="topicLecture_table">
      <Tables :data="dataList" @onTrainInfo="onTrainInfo"/>
    </div>
    <!--分页栏-->
    <div class="RCPagination">
      <RCPagination ref="pagination" v-model="dataList" :api="api" :startRequest="false"/>
    </div>
    <TrainInfoDia ref="trainInfo" :type="3" />
  </div>
</template>
<script>
import RCPagination from "@/components/pagination/paginationManage";
import { importOtherTrain } from "@/api/studyService";
import ExcelImport from "@/components/exceImport";
import { otherTrainRecordTemplate } from "@/assets/excel/index.js";

import { getTopicLecturePageNew } from "@/api/topicLecture";
import Search from "@/pages/topicLecture/components/search.vue";
import Tables from "@/pages/topicLecture/components/table.js";
import TrainInfoDia from "@/pages/topicLecture/components/trainInfoDia.vue";
import TopicHeader from "@/pages/topicLecture/components/topicHeader.vue"

export default {
  name: "otherTrainRecord",
  components: { Tables, Search, RCPagination, ExcelImport, TrainInfoDia, TopicHeader },
  data() {
    return {
      dataList: [],
      api: getTopicLecturePageNew,
      dataname: "",
      importInfo: {
        show: false,
        title: "",
        nowType: 0,
      },
      importApi: importOtherTrain,
      otherTrainRecordTemplate: otherTrainRecordTemplate,
      lectureTypes: [4],
      currentTopicInfo: {},
    };
  },
  created() {
    this.$nextTick(() => {
      this.searchHandle();
    })
  },
  methods: {
    /**
     * 导入其他集中培训记录
     */
     importSuccess() {
      this.$refs["pagination"].search(this.dataname);
    },
    //搜索
    searchHandle(data = {}) {
      this.dataname = {...data, lectureTypes: this.lectureTypes};
      if (!data.lectureId) {
        this.currentTopicInfo = {};
      }
      this.$refs["pagination"].search(this.dataname);
    },


    onTrainInfo(row) {
      this.$refs.trainInfo.show({
        userId: row.uuid,
        lectureTypes: this.lectureTypes
      });
    },

    changeTopic(item) {
      this.currentTopicInfo = item;
    }

  }
};
</script>
<style lang="scss" scoped>
/deep/.topicLecture_table .el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #FFFFFF;
}
</style>
